import React, { useState, useEffect, useCallback } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import Logo from './Logo';
import { navLinks, brand } from '../mock';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const onScroll = useCallback(() => {
    setScrolled(window.scrollY > 20);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  return (
    <header className={`sticky top-0 z-50 transition-colors ${scrolled ? 'bg-[#FFF8EC]/95 backdrop-blur border-b-2 border-[#2C3E50]' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-3 flex items-center justify-between">
        <a href="#home" className="shrink-0"><Logo /></a>
        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} className="px-3 py-2 rounded-md text-[#2C3E50] font-semibold hover:bg-[#F4B93E]/30 hover:-translate-y-0.5">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <div className="hidden xl:flex items-center gap-4 leading-tight">
            <a href={`tel:${brand.phoneRaw}`} className="inline-flex items-center gap-2 text-[#2C3E50] font-bold text-sm">
              <Phone size={13} className="text-[#E64B2B]" /> {brand.phone}
            </a>
            <a href={`tel:${brand.phone2Raw}`} className="inline-flex items-center gap-2 text-[#2C3E50] font-bold text-sm">
              <Phone size={13} className="text-[#4FB3B8]" /> {brand.phone2}
            </a>
          </div>
          <a href="#register" className="px-4 py-2 rounded-md bg-[#E64B2B] text-white font-bold border-2 border-[#2C3E50] hover:bg-[#2C3E50] hover:border-[#2C3E50]">
            Register for FREE Demo
          </a>
        </div>
        <button className="lg:hidden p-2 rounded-md border-2 border-[#2C3E50]" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#FFF8EC] border-t-2 border-[#2C3E50]">
          <div className="px-5 py-4 flex flex-col gap-1">
            {navLinks.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="px-3 py-2 rounded-md font-semibold hover:bg-[#F4B93E]/30">
                {l.label}
              </a>
            ))}
            <a href="#register" onClick={() => setOpen(false)} className="mt-2 px-4 py-2 rounded-md bg-[#E64B2B] text-white font-bold text-center border-2 border-[#2C3E50]">
              Register for FREE Demo
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
